import React, { useState, useEffect, useCallback, useRef } from 'react';
import './internos.css';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUsers } from '../../context/usersContext';
import FormattedInput from '../../components/FormatdInput/formatFunctions';
import { useLocation } from 'react-router-dom';
import Modal from '../../components/modal/index';
import AddAddress from './addAddress';
import EditAddress from './editAddress';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import File from '../../assets/icons/file.svg';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import TooltipInfo from '../../components/TooltipInfo/';
import PageHeader from '../../components/PageHeader';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import BinaryFileLink from '../../components/BinaryFileLink';
import { BINARY_RESOURCES, hasBinaryField } from '../../utils/binaryFile';
import LocationAutocomplete from '../../components/LocationAutocomplete';
import { pickChangedFields, isSameValue } from '../../utils/changedFields';
import { locationIdFromTypedText, locationLabel, validateLocationSelection } from '../../utils/locationSelection';


const SocialService = () => {
  // Estado para feedback do botão de envio
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const { userInfo, buildUnitReadParams } = useUsers();
  const {
    updateInternal,
    listInternals,
    addSocialService,
    listSocialService,
    updateSocialService,
    addAssistance,
    listAssistance,
    listAddressByInternal,
    listKin,
    createKin,
    updateKin,
    addDeficiencyInternal,
    listDeficiencyInternal,
    updateDeficiencyInternal,
    getInternalById,
  } = useInternals();
  const {
    listGender,
    listColorEthnicity,
    listMaritalStatus,
    listScholarity,
    listSexualOrientation,
    listTypeRelationInternal,
    listTypeFiles,
    listReligions,
    listProfessions,
    listTypeVisits,
    listSocialProgram,
    listFamilySocialProgram,
    listDeficiencys
  } = useAuxiliaries();

  const [internalDetails, setInternalDetails] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [typeFiles, setTypeFiles] = useState([]);
  const [religions, setReligions] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [socialProgram, setSocialProgram] = useState([]);
  const [familySocialProgram, setFamilySocialProgram] = useState([]);
  const [typeVisits, setTypeVisits] = useState([]);
  const [genders, setGenders] = useState([]);
  const [sexualOrientations, setSexualOrientations] = useState([]);
  const [colorsEthnicity, setColorsEthnicity] = useState([]);
  const [maritalStatuses, setMaritalStatuses] = useState([]);
  const [scholarities, setScholarities] = useState([]);
  const [evolutions, setEvolutions] = useState([]);
  const [currentTab, setCurrentTab] = useState('dados');
  const [isModalAddressOpen, setIsModalAddressOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [formData, setFormData] = useState(initializeFormData());
  const [originalData, setOriginalData] = useState(null);

  const [editingKinId, setEditingKinId] = useState(null);
  const [kins, setKins] = useState([]);
  const [showKinModal, setShowKinModal] = useState(false);
  // Estado para lista de deficiências
  const [deficiencys, setDeficiencys] = useState([]);
  // Registros de deficiência do interno (timeline)
  const [deficiencyRecords, setDeficiencyRecords] = useState([]);
  const [editingDeficiencyId, setEditingDeficiencyId] = useState(null);
  // Estado para formulário de deficiência
  const [deficiencyForm, setDeficiencyForm] = useState({
    deficiency: '',
    duration: '',
    limitation: '',
    observation: '',
    date: '',
  });
  const [isDeficiencySubmitting, setIsDeficiencySubmitting] = useState(false);
  const [showDeficiencyModal, setShowDeficiencyModal] = useState(false);
  // Deficiência em edição como veio do GET: base para enviar só o que mudou no PATCH
  const originalDeficiencyRef = useRef(null);
  const [isKinSubmitting, setIsKinSubmitting] = useState(false);
  const [isEvolutionSubmitting, setIsEvolutionSubmitting] = useState(false);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const [kinForm, setKinForm] = useState({
    name: '',
    cpf: '',
    rg: '',
    social_name: '',
    date_of_birth: '',
    nationality_country: '',
    naturalness_city: '',
    responsable: '',
    income: '',
    already_arrested: false,
    situation_with_justice: '',
    observation: '',
    registered: true,
    gender: 0,
    sexual_orientation: 0,
    color_or_ethnicity: 0,
    marital_status: 0,
    scholarity: 0,
    relationship: 0,
  });
  const [relationships, setRelationships] = useState([]);
  // O GET devolve o texto de país/cidade; o ID só existe quando o usuário escolhe na lista
  const [nationalityName, setNationalityName] = useState('');
  const [naturalnessName, setNaturalnessName] = useState('');
  const [internalLocationIds, setInternalLocationIds] = useState({ nationality_country: '', naturalness_city: '' });
  // Texto de país/cidade do interno como veio do GET: só limpa (null) se o usuário esvaziar um campo que tinha valor
  const originalLocationRef = useRef({ nationality: '', naturalness: '' });
  const [kinNationalityName, setKinNationalityName] = useState('');
  const [kinNaturalnessName, setKinNaturalnessName] = useState('');
  // Parente em edição como veio do GET: base para enviar só o que mudou no PATCH
  const originalKinRef = useRef(null);

  const { internalId: stateInternalId } = location.state || {};
  const internalId = formData.internal || stateInternalId;

  const normalizeText = (value) => {
    if (!value) return '';
    return value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const openTextFields = new Set([
    'name',
    'social_name',
    'fathers_name',
    'mothers_name',
    'who_have_docs',
    'observation_about_relationship',
    'person_in_family',
    'currently_responsible_for_family',
    'observation_about_work',
    'synthesis',
    'observation_childern',
    'evolution',
    'voter_registration',
  ]);

  const openKinTextFields = new Set([
    'name',
    'rg',
    'social_name',
    'responsable',
    'situation_with_justice',
    'observation',
    'occupation',
  ]);

  function initializeFormData() {
    return {
      internal: '',
      date: '',
      living_father: '',
      living_mother: '',
      religion: '',
      documents_have: [],
      who_have_docs: '',
      family_relationship: '',
      observation_about_relationship: '',
      person_in_family: '',
      degree_of_kinship: '',
      contact_person_in_family: '',
      number_of_children: '',
      type_visit: [],
      social_program: [],
      family_in_social_program: [],
      prison_aid: '',
      economic_position_in_family: '',
      responsible_family: '',
      income: '',
      currently_responsible_for_family: '',
      contact_currently_responsible: '',
      worked: '',
      profession: [],
      work_in_the_unit: '',
      observation_about_work: '',
      responsible_for_disabled: '',
      responsible_for_under_twelve: '',
      street_situation: '',
      synthesis: '',
      voter_registration: '',
      sons_with_same_parents: null,
      observation_childern: '',
      file: null,
    };
  }


  useEffect(() => {
    const fetchAuxiliaryData = async () => {
      if (!internalDetails) return;
      try {
        const [
          genderList,
          colorList,
          maritalList,
          scholarityList,
          sexualOrientationList,
          relationshipList,
          deficiencyList,
        ] = await Promise.all([
          listGender(),
          listColorEthnicity(),
          listMaritalStatus(),
          listScholarity(),
          listSexualOrientation(),
          listTypeRelationInternal(),
          listDeficiencys(),
        ]);

        setGenders(genderList || []);
        setColorsEthnicity(colorList || []);
        setMaritalStatuses(maritalList || []);
        setScholarities(scholarityList || []);
        setSexualOrientations(sexualOrientationList || []);
        setRelationships(relationshipList || []);
        setDeficiencys(deficiencyList || []);

        setFormData((prevFormData) => ({
          ...prevFormData,
          color_or_ethnicity: Array.isArray(colorList?.data?.results)
            ? colorList.data.results.find((c) => c.name === internalDetails.color_or_ethnicity)?.id || ''
            : '',
          gender: Array.isArray(genderList?.data?.results)
            ? genderList.data.results.find((g) => g.name === internalDetails.gender)?.id || ''
            : '',
          marital_status: Array.isArray(maritalList?.data?.results)
            ? maritalList.data.results.find((m) => m.name === internalDetails.marital_status)?.id || ''
            : '',
        }));
      } catch (error) {
        console.error('Erro ao buscar dados auxiliares:', error);
      }
    };
    fetchAuxiliaryData();
  }, [internalDetails, listGender, listColorEthnicity, listMaritalStatus, listScholarity, listSexualOrientation, listTypeRelationInternal, listDeficiencys]);

  const fetchAddresses = useCallback(async (internalId) => {
    if (!internalId) {
      toast.warning('Nenhum ID de interno fornecido para buscar endereços');
      return;
    }

    try {
      const addresses = await listAddressByInternal(internalId);
      if (Array.isArray(addresses)) {
        setAddresses(addresses);
      } else {
        setAddresses([]);
      }
    } catch (error) {
      console.error('Erro ao buscar endereços:', error);
      setAddresses([]);
    }
  }, [listAddressByInternal]);

  const handleInternalSelect = useCallback(async (internal) => {
    try {
      // A lista/busca de internos devolve nationality_country/naturalness_city como ID;
      // só o retrieve (getInternalById) devolve o texto desses dois campos. Busca à parte
      // e sobrepõe apenas esses dois campos, sem trocar a fonte do restante dos dados.
      let internalWithLocationText = internal;
      try {
        const fullInternal = await getInternalById(internal.id);
        if (fullInternal) {
          internalWithLocationText = {
            ...internal,
            nationality_country: fullInternal.nationality_country,
            naturalness_city: fullInternal.naturalness_city,
          };
        }
      } catch (err) {
        console.error('Erro ao buscar nacionalidade/naturalidade do interno:', err);
      }

      setFormData((prevFormData) => ({
        ...prevFormData,
        ...internalWithLocationText,
        internal: internal.id,
      }));

      setInternalDetails(internalWithLocationText);

      // Buscar dados do serviço social associados ao interno
      const socialServiceResponse = await listSocialService(internal.id);
      const socialServiceData = socialServiceResponse?.results?.[0] || initializeFormData();

      setFormData((prevFormData) => ({
        ...prevFormData,
        ...socialServiceData,
        internal: internal.id,
      }));

      setOriginalData(socialServiceData);

      // Buscar evoluções associadas ao interno
      const evolutionResponse = await listAssistance(internal.id);
      if (Array.isArray(evolutionResponse)) {
        setEvolutions(evolutionResponse);
      } else {
        console.warn("Resposta inesperada de listAssistance:", evolutionResponse);
        setEvolutions([]);
      }
      // Buscar endereços
      await fetchAddresses(internal.id);

      // Buscar deficiências do interno (timeline)
      try {
        const deficiencyResponse = await listDeficiencyInternal(internal.id);
        setDeficiencyRecords(deficiencyResponse?.results || []);
        setDeficiencyForm({ deficiency: '', duration: '', limitation: '', observation: '', date: '' });
        setEditingDeficiencyId(null);
      } catch (err) {
        console.error('Erro ao carregar dados de deficiência:', err);
        setDeficiencyRecords([]);
      }
    } catch (error) {
      console.error("Erro ao carregar dados do interno:", error);
      toast.error("Erro ao carregar dados do interno.");
    }
  }, [listSocialService, fetchAddresses, listAssistance, listDeficiencyInternal, getInternalById]);

  // Handler para formulário de deficiência
  const handleDeficiencyChange = (e) => {
    const { name, value } = e.target;
    setDeficiencyForm((prev) => ({
      ...prev,
      [name]: name === 'observation' ? normalizeText(value) : value
    }));
  };

  // Função para salvar/atualizar deficiência
  const handleSaveDeficiency = async () => {
    if (!formData.internal) {
      toast.warning('Nenhum interno selecionado.');
      return;
    }
    if (!deficiencyForm.deficiency || !deficiencyForm.duration || !deficiencyForm.limitation) {
      toast.warning('Por favor, preencha todos os campos obrigatórios.');
      return;
    }
    setIsDeficiencySubmitting(true);
    const payload = {
      internal: formData.internal,
      deficiency: Number(deficiencyForm.deficiency),
      duration: deficiencyForm.duration,
      limitation: deficiencyForm.limitation,
      observation: deficiencyForm.observation,
      date: deficiencyForm.date ? new Date(deficiencyForm.date).toISOString() : new Date().toISOString(),
      health_professional: userInfo.id,
    };
    try {
      if (editingDeficiencyId) {
        // PATCH: só o que mudou em relação ao registro carregado
        const original = originalDeficiencyRef.current;
        const changedForm = pickChangedFields(deficiencyForm, original?.form || {});
        if (Object.keys(changedForm).length === 0) {
          toast.warning('Nenhuma alteração para salvar.');
          handleCloseDeficiencyModal();
          return;
        }
        const changedPayload = {};
        Object.keys(changedForm).forEach((key) => {
          changedPayload[key] = payload[key];
        });
        // Profissional que editou: só vai se for diferente do registro
        if (!isSameValue(payload.health_professional, original?.healthProfessional)) {
          changedPayload.health_professional = payload.health_professional;
        }
        await updateDeficiencyInternal(editingDeficiencyId, changedPayload);
      } else {
        await addDeficiencyInternal(payload);
      }
      const refreshed = await listDeficiencyInternal(formData.internal);
      setDeficiencyRecords(refreshed?.results || []);
      setDeficiencyForm({ deficiency: '', duration: '', limitation: '', observation: '', date: '' });
      setEditingDeficiencyId(null);
      setShowDeficiencyModal(false);
    } catch (error) {
      console.error('Erro ao salvar deficiência:', error);
    } finally {
      setIsDeficiencySubmitting(false);
    }
  };

  const handleEditDeficiency = (record) => {
    const initialDeficiencyForm = {
      deficiency: record.deficiency?.id || record.deficiency || '',
      duration: record.duration || '',
      limitation: record.limitation || '',
      observation: record.observation || '',
      date: record.date ? record.date.substring(0, 10) : '',
    };
    setDeficiencyForm(initialDeficiencyForm);
    originalDeficiencyRef.current = {
      form: initialDeficiencyForm,
      healthProfessional: record.health_professional,
    };
    setEditingDeficiencyId(record.id);
    setShowDeficiencyModal(true);
  };

  const handleCloseDeficiencyModal = () => {
    setShowDeficiencyModal(false);
    setEditingDeficiencyId(null);
    setDeficiencyForm({ deficiency: '', duration: '', limitation: '', observation: '', date: '' });
  };

  // Texto de país/cidade do interno (GET) para exibir; o ID só existe quando o usuário escolhe na lista.
  // Efeito próprio (sem depender das listas auxiliares) para o texto e a base de comparação ficarem sempre sincronizados.
  useEffect(() => {
    const nationality = locationLabel(internalDetails?.nationality_country);
    const naturalness = locationLabel(internalDetails?.naturalness_city);
    originalLocationRef.current = { nationality, naturalness };
    setNationalityName(nationality);
    setNaturalnessName(naturalness);
    setInternalLocationIds({ nationality_country: '', naturalness_city: '' });
  }, [internalDetails]);

  // Atualiza formData com IDs correspondentes quando internalDetails mudar e listas auxiliares estiverem carregadas
  useEffect(() => {
    if (
      internalDetails &&
      genders.length > 0 &&
      colorsEthnicity.length > 0 &&
      maritalStatuses.length > 0 &&
      sexualOrientations.length > 0
    ) {
      setFormData((prev) => ({
        ...prev,
        gender: genders.find((g) => g.name === internalDetails.gender)?.id || '',
        color_or_ethnicity: colorsEthnicity.find((c) => c.name === internalDetails.color_or_ethnicity)?.id || '',
        marital_status: maritalStatuses.find((m) => m.name === internalDetails.marital_status)?.id || '',
        sexual_orientation: sexualOrientations.find((s) => s.name === internalDetails.sexual_orientation || s.id === internalDetails.sexual_orientation)?.id || '',
      }));
    }
  }, [internalDetails, genders, colorsEthnicity, maritalStatuses, sexualOrientations]);

  useEffect(() => {
    if (formData.internal) {
      listKin({ internal: formData.internal, start_date: '2025-01-01' })
        .then((res) => setKins(res.results))
        .catch((err) => console.error('Erro ao listar parentes:', err));
    }
  }, [formData.internal, listKin]);

  // Handlers de país/cidade do interno (aba Socioeconômico)
  const handleNationalityChange = (text) => {
    setNationalityName(text);
    setInternalLocationIds((prev) => ({ ...prev, nationality_country: locationIdFromTypedText(text) }));
  };

  const handleNationalitySelect = (selectedCountry) => {
    setNationalityName(selectedCountry.name);
    setInternalLocationIds((prev) => ({ ...prev, nationality_country: selectedCountry.id }));
  };

  const handleNaturalnessChange = (text) => {
    setNaturalnessName(text);
    setInternalLocationIds((prev) => ({ ...prev, naturalness_city: locationIdFromTypedText(text) }));
  };

  const handleNaturalnessSelect = (selectedCity) => {
    setNaturalnessName(selectedCity.name);
    setInternalLocationIds((prev) => ({ ...prev, naturalness_city: selectedCity.id }));
  };

  // Handlers de país/cidade do parente
  const handleKinNationalityChange = (text) => {
    setKinNationalityName(text);
    setKinForm((prev) => ({ ...prev, nationality_country: locationIdFromTypedText(text) }));
  };

  const handleKinNationalitySelect = (selectedCountry) => {
    setKinNationalityName(selectedCountry.name);
    setKinForm((prev) => ({ ...prev, nationality_country: selectedCountry.id }));
  };

  const handleKinNaturalnessChange = (text) => {
    setKinNaturalnessName(text);
    setKinForm((prev) => ({ ...prev, naturalness_city: locationIdFromTypedText(text) }));
  };

  const handleKinNaturalnessSelect = (selectedCity) => {
    setKinNaturalnessName(selectedCity.name);
    setKinForm((prev) => ({ ...prev, naturalness_city: selectedCity.id }));
  };

  // Handler para formulário de parente
  const handleChangeKinForm = (e) => {
    const { name, value, type, checked } = e.target;
    const nextValue = type === 'checkbox'
      ? checked
      : openKinTextFields.has(name)
        ? normalizeText(value)
        : value;
    setKinForm((prev) => ({
      ...prev,
      [name]: nextValue,
    }));
  };

  // Função para fechar o modal de Parente e resetar estado
  const handleCloseKinModal = () => {
    setShowKinModal(false);
    setKinNationalityName('');
    setKinNaturalnessName('');
    setKinForm({
      name: '',
      cpf: '',
      rg: '',
      social_name: '',
      date_of_birth: '',
      nationality_country: '',
      naturalness_city: '',
      responsable: '',
      income: '',
      already_arrested: false,
      situation_with_justice: '',
      observation: '',
      registered: true,
      gender: 0,
      sexual_orientation: 0,
      color_or_ethnicity: 0,
      marital_status: 0,
      scholarity: 0,
      relationship: 0,
    });
    setEditingKinId(null);
  };

  // Monta o payload do parente (create e update usam o mesmo formato)
  const buildKinPayload = (kinData) => {
    const payload = {
      name: kinData.name,
      cpf: kinData.cpf,
      rg: kinData.rg,
      social_name: kinData.social_name,
      date_of_birth: kinData.date_of_birth,
      birth_date: kinData.date_of_birth,
      gender: kinData.gender ? Number(kinData.gender) : undefined,
      color_or_ethnicity: kinData.color_or_ethnicity ? Number(kinData.color_or_ethnicity) : undefined,
      marital_status: kinData.marital_status ? Number(kinData.marital_status) : undefined,
      sexual_orientation: kinData.sexual_orientation ? Number(kinData.sexual_orientation) : undefined,
      education: kinData.education ? Number(kinData.education) : undefined,
      scholarity: kinData.scholarity ? Number(kinData.scholarity) : undefined,
      relationship: kinData.relationship ? Number(kinData.relationship) : undefined,
      income: kinData.income !== '' ? Number(kinData.income) : undefined,
      situation_with_justice: kinData.situation_with_justice,
      nationality_country: kinData.nationality_country,
      naturalness_city: kinData.naturalness_city,
      phone: kinData.phone,
      responsable: kinData.responsable,
      occupation: kinData.occupation,
      observation: kinData.observation,
      already_arrested: kinData.already_arrested,
      registered: kinData.registered,
      internal: formData.internal,
    };

    // Remove campos indefinidos, nulos ou string vazia
    Object.keys(payload).forEach((key) => {
      if (
        payload[key] === undefined ||
        payload[key] === null ||
        payload[key] === ''
      ) {
        delete payload[key];
      }
    });
    return payload;
  };

  // Criar parente 
  const handleSubmitKinForm = async () => {
    if (isKinSubmitting) return;
    if (!kinForm.name || !kinForm.relationship) {
      toast.warning("Nome e Relacionamento são obrigatórios.");
      return;
    }
    if (!validateLocationSelection(kinForm)) return;

    const payload = buildKinPayload(kinForm);

    setIsKinSubmitting(true);
    try {
      await createKin(payload);

      setKinNationalityName('');
      setKinNaturalnessName('');
      setKinForm({
        name: '',
        cpf: '',
        rg: '',
        social_name: '',
        date_of_birth: '',
        nationality_country: '',
        naturalness_city: '',
        responsable: '',
        income: '',
        already_arrested: false,
        situation_with_justice: '',
        observation: '',
        registered: true,
        gender: 0,
        sexual_orientation: 0,
        color_or_ethnicity: 0,
        marital_status: 0,
        scholarity: 0,
        relationship: 0,
      });
      setShowKinModal(false);
      // Recarrega parentes
      if (formData.internal) {
        listKin({ internal: formData.internal, start_date: '2025-01-01' })
          .then((res) => setKins(res.results))
          .catch((err) => console.error('Erro ao listar parentes:', err));
      }
    } catch (error) {
      console.error("Erro ao criar parente:", error);
      toast.error("Erro ao criar parente.");
    } finally {
      setIsKinSubmitting(false);
    }
  };

  // EDITAR PARENTE
  const handleEditKin = (kin) => {
    setKinNationalityName(locationLabel(kin.nationality_country));
    setKinNaturalnessName(locationLabel(kin.naturalness_city));
    const initialKinForm = {
      ...kin,
      nationality_country: '',
      naturalness_city: '',
      gender: kin.gender?.id || kin.gender || 0,
      sexual_orientation: kin.sexual_orientation?.id || kin.sexual_orientation || 0,
      color_or_ethnicity: kin.color_or_ethnicity?.id || kin.color_or_ethnicity || 0,
      marital_status: kin.marital_status?.id || kin.marital_status || 0,
      scholarity: kin.scholarity?.id || kin.scholarity || 0,
      relationship: kin.relationship?.id || kin.relationship || 0,
    };
    setKinForm(initialKinForm);
    originalKinRef.current = {
      form: initialKinForm,
      nationalityText: locationLabel(kin.nationality_country),
      naturalnessText: locationLabel(kin.naturalness_city),
    };
    setEditingKinId(kin.id); // Define ID para saber que é edição
    setShowKinModal(true);
  };

  // Nova função: Atualiza um parente existente
  const handleUpdateKinForm = async () => {
    if (isKinSubmitting) return;
    if (!editingKinId) return;

    if (!kinForm.name || !kinForm.relationship) {
      toast.warning("Nome e Relacionamento são obrigatórios.");
      return;
    }
    if (!validateLocationSelection(kinForm)) return;

    // PATCH: só o que mudou em relação ao parente carregado
    const original = originalKinRef.current;
    const changedPayload = pickChangedFields(buildKinPayload(kinForm), buildKinPayload(original?.form || {}));
    // País/cidade esvaziados pelo usuário (tinham valor no GET): envia null para limpar
    if (original?.nationalityText && !kinNationalityName.trim()) changedPayload.nationality_country = null;
    if (original?.naturalnessText && !kinNaturalnessName.trim()) changedPayload.naturalness_city = null;

    if (Object.keys(changedPayload).length === 0) {
      toast.warning('Nenhuma alteração para salvar.');
      handleCloseKinModal();
      return;
    }

    setIsKinSubmitting(true);
    try {
      await updateKin(editingKinId, changedPayload);

      setShowKinModal(false);
      setEditingKinId(null);
      setKinNationalityName('');
      setKinNaturalnessName('');

      setKinForm({
        name: '',
        cpf: '',
        rg: '',
        social_name: '',
        date_of_birth: '',
        nationality_country: '',
        naturalness_city: '',
        responsable: '',
        income: '',
        already_arrested: false,
        situation_with_justice: '',
        observation: '',
        registered: true,
        gender: 0,
        sexual_orientation: 0,
        color_or_ethnicity: 0,
        marital_status: 0,
        scholarity: 0,
        relationship: 0,
      });

      if (formData.internal) {
        listKin({ internal: formData.internal, start_date: '2025-01-01' })
          .then((res) => setKins(res.results))
          .catch((err) => console.error('Erro ao listar parentes:', err));
      }
    } catch (error) {
      console.error("Erro ao atualizar parente:", error);
      toast.error("Erro ao atualizar parente.");
    } finally {
      setIsKinSubmitting(false);
    }
  };


  const fetchData = useCallback(async () => {
    try {
      // Carrega apenas os dados auxiliares
      const [files, religions, professions, visits, socialPrograms, familyPrograms] = await Promise.all([
        listTypeFiles(),
        listReligions(),
        listProfessions(),
        listTypeVisits(),
        listSocialProgram(),
        listFamilySocialProgram(),
      ]);

      setTypeFiles(files?.results || []);
      setReligions(religions?.results || []);
      setProfessions(professions?.results || []);
      setTypeVisits(visits?.results || []);
      setSocialProgram(socialPrograms?.results || []);
      setFamilySocialProgram(familyPrograms?.results || []);
    } catch (error) {
      console.error('Erro ao carregar dados auxiliares:', error);
      toast.error('Erro ao carregar dados auxiliares.');
    }
  }, [listTypeFiles, listReligions, listProfessions, listTypeVisits, listSocialProgram, listFamilySocialProgram]);


  // UseEffect inicial para carregar apenas os dados auxiliares
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const fetchInternalById = async () => {
      if (!internalId) return;

      try {
        const params = buildUnitReadParams({ id: internalId });

        const internalsResponse = await listInternals(params);
        const internalsData = internalsResponse?.results || [];


        if (internalsData.length === 1) {
          handleInternalSelect(internalsData[0]);
        }
      } catch (error) {
        console.error(" Erro ao carregar dados do interno:", error);
      }
    };

    fetchInternalById();
  }, [internalId, listInternals, buildUnitReadParams, handleInternalSelect]);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prevFormData) => {
      if (type === 'file') {
        return { ...prevFormData, [name]: files[0] };
      } else if (['documents_have', 'type_visit', 'social_program', 'family_in_social_program'].includes(name)) {
        const options = Array.from(e.target.selectedOptions, (option) => option.value);
        return { ...prevFormData, [name]: options };
      } else if (['living_father', 'living_mother', 'prison_aid', 'responsible_family', 'worked', 'work_in_the_unit', 'responsible_for_disabled', 'responsible_for_under_twelve', 'street_situation'].includes(name)) {
        return { ...prevFormData, [name]: value === 'true' };
      } else if (name === "internals" || name === "internal") {
        return { ...prevFormData, [name]: value };
      } else if (name === "aka") {
        return { ...prevFormData, [name]: openTextFields.has(name) ? normalizeText(value) : value };
      } else {
        const nextValue = openTextFields.has(name) ? normalizeText(value) : value;
        return { ...prevFormData, [name]: nextValue !== null ? nextValue : '' };
      }
    });
  };

  const toggleArrayFieldValue = (fieldName, rawValue, checked) => {
    const value = Number(rawValue);
    if (Number.isNaN(value)) return;

    setFormData((prev) => {
      const currentValues = Array.isArray(prev[fieldName]) ? prev[fieldName] : [];
      const nextValues = checked
        ? Array.from(new Set([...currentValues, value]))
        : currentValues.filter((item) => Number(item) !== value);

      return {
        ...prev,
        [fieldName]: nextValues,
      };
    });
  };


  // Função para lidar com o envio de uma nova evolução
  const handleEvolutionSubmit = async () => {
    if (isEvolutionSubmitting) return;
    setIsEvolutionSubmitting(true);
    try {
      const data = {
        internal: formData.internal,
        social_worker: userInfo.id,
        date: new Date().toISOString(),
        data: formData.evolution,
      };
      await addAssistance(data);
      const evolutionResponse = await listAssistance(formData.internal);
      setEvolutions(evolutionResponse);
      setFormData({ ...formData, evolution: '' });
    } catch (error) {
      console.error("Erro ao enviar evolução:", error);
    } finally {
      setIsEvolutionSubmitting(false);
    }
  };

  // FormData completo do serviço social (criação, POST)
  const buildSocialServiceFormData = () => {
    const socialServiceData = new FormData();
    socialServiceData.append('internal', formData.internal);
    socialServiceData.append('social_worker', userInfo.id);
    Object.keys(formData).forEach((key) => {
      if (key !== 'internal' && key !== 'file' && formData[key] !== undefined && formData[key] !== null) {
        if (Array.isArray(formData[key])) {
          formData[key].forEach((item) => socialServiceData.append(key, item));
        } else {
          socialServiceData.append(key, formData[key]);
        }
      }
    });
    if (formData.file && typeof formData.file !== 'string') {
      socialServiceData.append('file', formData.file);
    }
    return socialServiceData;
  };

  // FormData só com o que mudou no serviço social (PATCH); null quando não há alteração
  const buildSocialServiceChanges = () => {
    const current = originalData || {};
    // Só campos do registro de serviço social (formData também guarda dados do interno e campos de tela)
    const socialKeys = Object.keys(formData).filter(
      (key) => !['id', 'internal', 'social_worker', 'file'].includes(key)
        && Object.prototype.hasOwnProperty.call(current, key)
    );
    const changed = pickChangedFields(formData, current, socialKeys);
    const hasNewFile = Boolean(formData.file && typeof formData.file !== 'string');
    if (Object.keys(changed).length === 0 && !hasNewFile) return null;

    const socialServiceData = new FormData();
    Object.keys(changed).forEach((key) => {
      const value = changed[key];
      if (value === undefined || value === null) return;
      if (Array.isArray(value)) {
        value.forEach((item) => socialServiceData.append(key, item));
      } else {
        socialServiceData.append(key, value);
      }
    });
    // Assistente social que editou: só vai se for diferente do registro
    if (!isSameValue(userInfo.id, current.social_worker)) {
      socialServiceData.append('social_worker', userInfo.id);
    }
    if (hasNewFile) {
      socialServiceData.append('file', formData.file);
    }
    return socialServiceData;
  };

  // Valores do interno como vieram do GET (mesmo mapeamento nome -> id usado ao carregar o formulário)
  const buildInternalBaseline = () => ({
    name: internalDetails?.name,
    social_name: internalDetails?.social_name,
    cpf: internalDetails?.cpf,
    fathers_name: internalDetails?.fathers_name,
    mothers_name: internalDetails?.mothers_name,
    date_of_birth: internalDetails?.date_of_birth,
    gender: genders.find((g) => g.name === internalDetails?.gender)?.id || '',
    color_or_ethnicity: colorsEthnicity.find((c) => c.name === internalDetails?.color_or_ethnicity)?.id || '',
    marital_status: maritalStatuses.find((m) => m.name === internalDetails?.marital_status)?.id || '',
    sexual_orientation: sexualOrientations.find(
      (s) => s.name === internalDetails?.sexual_orientation || s.id === internalDetails?.sexual_orientation
    )?.id || '',
    aka: internalDetails?.aka || [],
  });

  // Salva dados primários do interno e serviço social (usado nas abas dados, familiar, socioeconomico)
  const handleSaveWithPrimaryData = async () => {
    if (!formData.internal) {
      toast.warning("Nenhum interno selecionado.");
      return;
    }
    if (!validateLocationSelection(internalLocationIds)) return;
    setIsSubmitting(true);
    try {
      // Monta o payload para dados primários do interno
      let akaArray = [];
      if (Array.isArray(formData.aka)) {
        akaArray = formData.aka
          .filter((item) => item && item.trim() !== "")
          .map((item) => item.trim());
      } else if (typeof formData.aka === "string" && formData.aka.trim() !== "") {
        akaArray = formData.aka
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item.length > 0);
      }
      if (!akaArray || !Array.isArray(akaArray)) {
        akaArray = [];
      }

      const payload = {
        name: formData.name,
        social_name: formData.social_name,
        cpf: formData.cpf,
        fathers_name: formData.fathers_name,
        mothers_name: formData.mothers_name,
        nationality_country: internalLocationIds.nationality_country,
        naturalness_city: internalLocationIds.naturalness_city,
        date_of_birth: formData.date_of_birth,
        marital_status: formData.marital_status,
        color_or_ethnicity: formData.color_or_ethnicity,
        gender: formData.gender,
        sexual_orientation: formData.sexual_orientation,
        aka: akaArray
      };
      Object.keys(payload).forEach((key) => {
        if (payload[key] === '' || payload[key] === undefined || payload[key] === null) {
          delete payload[key];
        }
      });

      // PATCH: só o que mudou em relação ao interno carregado
      const internalChanges = pickChangedFields(payload, buildInternalBaseline());
      // País/cidade esvaziados pelo usuário (tinham valor no GET): envia null para limpar
      if (originalLocationRef.current.nationality && !nationalityName.trim()) {
        internalChanges.nationality_country = null;
      }
      if (originalLocationRef.current.naturalness && !naturalnessName.trim()) {
        internalChanges.naturalness_city = null;
      }
      const hasInternalChanges = Object.keys(internalChanges).length > 0;

      // Serviço social: atualização (PATCH) só com o que mudou; criação (POST) com todos os campos
      const socialServiceChanges = originalData?.id ? buildSocialServiceChanges() : null;

      if (originalData?.id && !hasInternalChanges && !socialServiceChanges) {
        toast.warning('Nenhuma alteração para salvar.');
        return;
      }

      if (hasInternalChanges) {
        await updateInternal(formData.internal, internalChanges);
      }
      // Atualizar ou criar serviço social
      if (originalData?.id) {
        if (socialServiceChanges) {
          await updateSocialService(originalData.id, socialServiceChanges);
        }
      } else {
        await addSocialService(buildSocialServiceFormData());
      }
      // Atualiza dados do interno após salvar
      const updatedInternalResponse = await listInternals(
        buildUnitReadParams({ id: formData.internal })
      );
      const updatedInternal = updatedInternalResponse?.results?.[0];
      if (updatedInternal) {
        await handleInternalSelect(updatedInternal);
      }
    } catch (error) {
      console.error("Erro ao salvar dados:", error);
      toast.error("Erro ao salvar dados.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Salva/atualiza apenas serviço social (usado nas abas trabalho e sintese)
  const handleSaveOnlySocialService = async () => {
    if (!formData.internal) {
      toast.warning("Nenhum interno selecionado.");
      return;
    }
    setIsSubmitting(true);
    try {
      // Atualização (PATCH) só com o que mudou; criação (POST) com todos os campos
      if (originalData?.id) {
        const socialServiceChanges = buildSocialServiceChanges();
        if (!socialServiceChanges) {
          toast.warning('Nenhuma alteração para salvar.');
          return;
        }
        await updateSocialService(originalData.id, socialServiceChanges);
      } else {
        await addSocialService(buildSocialServiceFormData());
      }
      // Atualiza dados do interno após salvar
      const updatedInternalResponse = await listInternals(
        buildUnitReadParams({ id: formData.internal })
      );
      const updatedInternal = updatedInternalResponse?.results?.[0];
      if (updatedInternal) {
        await handleInternalSelect(updatedInternal);
      }
    } catch (error) {
      console.error("Erro ao salvar serviço social:", error);
      toast.error("Erro ao salvar serviço social.");
    } finally {
      setIsSubmitting(false);
    }
  };


  // Função para abrir o modal de adição de endereço
  const handleAddAddress = () => {
    setEditingAddress(null);
    setIsModalAddressOpen(true);
  };

  // Função para abrir o modal de edição de endereço
  const handleEditAddress = (address) => {
    setEditingAddress(address);
    setIsModalAddressOpen(true);
  };

  // Função para fechar o modal de endereço
  const closeModal = () => {
    setIsModalAddressOpen(false);
    fetchAddresses(internalId);
  };


  const renderTabContent = () => {
    switch (currentTab) {
      case 'dados':
        return renderDadosTab();
      case 'deficiency':
        return renderDeficiencyTab();
      case 'familiar':
        return renderFamiliarTab();
      case 'socioeconomico':
        return renderSocioeconomicoTab();
      case 'trabalho':
        return renderTrabalhoTab();
      case 'endereco':
        return renderEnderecoTab();
      case 'sintese':
        return renderSinteseTab();
      case 'evolucao':
        return renderEvolucaoTab();
      default:
        return <div />;
    }
  };


  // Renderização da aba 'Dados'
  const renderDadosTab = () => (
    <div>
      <div className='social-form-group'>
        <label>Nome</label>
        <input type="text" name="name" value={formData.name || ''} onChange={handleInputChange} />
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Nome Social</label>
          <input type="text" name="social_name" value={formData.social_name || ''} onChange={handleInputChange} />
        </div>
        {/* AKA input with chips and remove button */}
        <div className="social-form-group">
          <label>Vulgos
            <TooltipInfo text="Para cadastrar mais de um Vulgo, digite o nome aperte enter." />
          </label>
          <div className="aka-input-wrapper">
            <input
              style={{ padding: '10px' }}
              type="text"
              name="akaInput"
              value={formData.akaInput || ""}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, akaInput: normalizeText(e.target.value) }))
              }
              onKeyDown={(e) => {
                if (e.key === "Enter" && formData.akaInput && formData.akaInput.trim() !== "") {
                  e.preventDefault();
                  setFormData((prev) => ({
                    ...prev,
                    aka: [...(prev.aka || []), normalizeText(prev.akaInput).trim()],
                    akaInput: ""
                  }));
                }
              }}
              placeholder="Digite e pressione Enter"
            />
          </div>
          <div className="aka-tags">
            {(formData.aka || []).map((aka, index) => (
              <span key={index} className="aka-tag">
                {aka}
                <button
                  type="button"
                  onClick={() => {
                    setFormData((prev) => ({
                      ...prev,
                      aka: prev.aka.filter((_, i) => i !== index)
                    }));
                  }}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Data de Nascimento</label>
          <input type="date" name="date_of_birth" value={formData.date_of_birth ? formData.date_of_birth.substring(0, 10) : ''} onChange={handleInputChange} />
        </div>
        <div className='social-form-group'>
          <label>CadÚnico</label>
          <input type="number" name="unit_cad" value={formData.unit_cad || ''} onChange={handleInputChange} />
        </div>
      </div>
      <div className='social-form-group'>
        <label>Documentos Possuídos</label>
        <div className="checkbox-group2">
          {typeFiles.map((typeFile) => (
            <label key={typeFile.id}>
              <input
                type="checkbox"
                value={typeFile.id}
                checked={formData.documents_have.includes(typeFile.id)}
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  const isChecked = e.target.checked;
                  setFormData((prev) => ({
                    ...prev,
                    documents_have: isChecked
                      ? [...prev.documents_have, value]
                      : prev.documents_have.filter((id) => id !== value),
                  }));
                }}
              />
              {typeFile.type}
            </label>
          ))}
        </div>
      </div>
      <div className='social-form-group'>
        <label>Quem Possui os Documentos</label>
        <input type="text" name="who_have_docs" value={formData.who_have_docs || ''} onChange={handleInputChange} />
      </div>

      {/* <input type="file" name="file" onChange={handleInputChange} /> */}

      <div className="line">
        <h4>Arquivo</h4>
        <div className="images-grid">
          {hasBinaryField(formData, 'file') && !formData.file && (
            <BinaryFileLink className='arquivo-incluso' resource={BINARY_RESOURCES.receptionSocialService} id={formData.id} field="file">
              <div style={{ width: 60, height: 60 }} className="image-thumbnail">
                <img src={File} alt="Arquivo" />
              </div>
            </BinaryFileLink>
          )}
          <div className='form-cadastro-interno'>
            <div style={{ width: 200, height: 100 }} className='image-upload-container'>
              <input type='file' name="file" onChange={handleInputChange} className="image-input" />
              <img src={File} alt="Upload icon" className="upload-icon" />
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <button
          className={` save-btn${isSubmitting ? ' btn-disabled' : ''}`}
          disabled={isSubmitting}
          onClick={handleSaveWithPrimaryData}
        >
          {isSubmitting ? "Enviando..." : "Salvar Dados"}
        </button>
      </div>
    </div>
  );

  // Renderização do formulário de deficiência (reutilizado no form principal e no modal)
  const renderDeficiencyForm = () => (
    <>
      <div className='social-form-group-duplo'>
        <div className="social-form-group">
          <label>Deficiência <span className="social-required-indicator">*</span></label>
          <select name="deficiency" value={deficiencyForm.deficiency} onChange={handleDeficiencyChange}>
            <option value="">Selecione</option>
            {deficiencys.map((def) => (
              <option key={def.id} value={def.id}>{def.name}</option>
            ))}
          </select>
        </div>
        <div className="social-form-group">
          <label>Data</label>
          <input type="date" name="date" value={deficiencyForm.date || ''} onChange={handleDeficiencyChange} />
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className="social-form-group">
          <label>Duração <span className="social-required-indicator">*</span></label>
          <select name="duration" value={deficiencyForm.duration} onChange={handleDeficiencyChange}>
            <option value="">Selecione</option>
            <option value="Temporária">Temporária</option>
            <option value="Permanente">Permanente</option>
          </select>
        </div>
        <div className="social-form-group">
          <label>Limitação <span className="social-required-indicator">*</span></label>
          <select name="limitation" value={deficiencyForm.limitation} onChange={handleDeficiencyChange}>
            <option value="">Selecione</option>
            <option value="Parcial">Parcial</option>
            <option value="Total">Total</option>
          </select>
        </div>
      </div>
      <div className="social-form-group">
        <label>Observação</label>
        <textarea name="observation" value={deficiencyForm.observation} onChange={handleDeficiencyChange} />
      </div>
    </>
  );

  // Renderização da aba 'Deficiência'
  const renderDeficiencyTab = () => (
    <div>
      {renderDeficiencyForm()}
      <div style={{ marginTop: 20 }}>
        <button
          className={`save-btn${isDeficiencySubmitting ? ' btn-disabled' : ''}`}
          disabled={isDeficiencySubmitting}
          onClick={handleSaveDeficiency}
        >
          {isDeficiencySubmitting ? 'Enviando...' : 'Salvar'}
        </button>
      </div>

      <div className="timeline" style={{ marginTop: 30 }}>
        <h4>Histórico de Deficiências</h4>
        <ul className="timeline-list">
          {deficiencyRecords.length > 0 ? (
            [...deficiencyRecords]
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((record, index) => (
                <li key={record.id || index} className="timeline-item">
                  <div className="timeline-date">
                    <FontAwesomeIcon icon={faClock} />
                    {' '}{new Date(record.date).toLocaleDateString('pt-BR')}
                    <FontAwesomeIcon
                      icon={faEdit}
                      style={{ marginLeft: 8, cursor: 'pointer' }}
                      onClick={() => handleEditDeficiency(record)}
                    />
                  </div>
                  <div className="timeline-content">
                    <strong>Deficiência:</strong> {record.deficiency_name}<br />
                    <strong>Duração:</strong> {record.duration}<br />
                    <strong>Limitação:</strong> {record.limitation}<br />
                    {record.observation && <><strong>Observação:</strong> {record.observation}</>}
                  </div>
                </li>
              ))
          ) : (
            <p>Nenhuma deficiência registrada.</p>
          )}
        </ul>
      </div>

      {showDeficiencyModal && (
        <Modal
          isOpen={true}
          onClose={handleCloseDeficiencyModal}
          closeModal={handleCloseDeficiencyModal}
          title="Editar Deficiência"
        >
          {renderDeficiencyForm()}
          <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
            <button
              className={`save-btn${isDeficiencySubmitting ? ' btn-disabled' : ''}`}
              disabled={isDeficiencySubmitting}
              onClick={handleSaveDeficiency}
            >
              {isDeficiencySubmitting ? 'Enviando...' : 'Atualizar'}
            </button>
            <button onClick={handleCloseDeficiencyModal}>Cancelar</button>
          </div>
        </Modal>
      )}
    </div>
  );

  // Renderização da aba 'Familiar'
  const renderFamiliarTab = () => {
    const familiares = (kins || []).filter(f => f) || [];
    return (
      <div>
        <div className='social-form-group-duplo'>
          <div className='social-form-group'>
            <label>Nome do Pai</label>
            <input type="text" name="fathers_name" value={formData.fathers_name || ''} onChange={handleInputChange} />
          </div>
          <div className='social-form-group'>
            <label>Nome da Mãe</label>
            <input type="text" name="mothers_name" value={formData.mothers_name || ''} onChange={handleInputChange} />
          </div>
        </div>

        <div className='social-form-group-duplo'>
          <div className='social-form-group'>
            <label>Pai Vivo</label>
            <select name="living_father" value={formData.living_father !== undefined ? formData.living_father.toString() : ''} onChange={handleInputChange}>
              <option value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
          <div className='social-form-group'>
            <label>Mãe Viva</label>
            <select name="living_mother" value={formData.living_mother !== undefined ? formData.living_mother.toString() : ''} onChange={handleInputChange}>
              <option value="">Selecione</option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>
        </div>
        <div className='social-form-group-duplo'>
          <div className='social-form-group'>
            <label>
              Pessoa na Família
              <TooltipInfo text="Uma pessoa de referência na família" />
            </label>
            <input type="text" name="person_in_family" value={formData.person_in_family || ''} onChange={handleInputChange} />
          </div>
          <div className='social-form-group'>
            <label>Grau de Parentesco</label>
            <select
              name="degree_of_kinship"
              value={formData.degree_of_kinship || ''}
              onChange={handleInputChange}
            >
              <option value="">Selecione</option>
              {relationships.map((rel) => (
                <option key={rel.id} value={rel.name}>{rel.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className='social-form-group-duplo'>
          <div className='social-form-group'>
            <label>Relacionamento Familiar</label>
            <select name="family_relationship" value={formData.family_relationship || ''} onChange={handleInputChange}>
              <option value=''>Selecione</option>
              <option>Excelente</option>
              <option>Bom</option>
              <option>Ruim</option>
              <option>Péssimo</option>
            </select>
          </div>
          <div className='social-form-group'>
            <label>Contato da Pessoa na Família</label>
            <FormattedInput type="telefone" name="contact_person_in_family" value={formData.contact_person_in_family || ''} onChange={handleInputChange} />
          </div>
        </div>
        <div className='social-form-group'>
          <label>
            Observação sobre Relacionamento
            <TooltipInfo text="Use este campo para detalhar o vínculo e a convivência familiar." />
          </label>
          <input type="text" name="observation_about_relationship" value={formData.observation_about_relationship || ''} onChange={handleInputChange} />
        </div>
        <div className='social-form-group'>
          <label>Número de Filhos</label>
          <input type="number" name="number_of_children" value={formData.number_of_children || ''} onChange={handleInputChange} />
        </div>
        <div className="social-form-group">
          <label htmlFor="sons_with_same_parents">Filhos com os mesmos pais:</label>
          <select
            id="sons_with_same_parents"
            name="sons_with_same_parents"
            value={formData.sons_with_same_parents ?? ""}
            onChange={(e) =>
              handleInputChange({
                target: {
                  name: "sons_with_same_parents",
                  value: e.target.value === "true"
                }
              })
            }
          >
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
        <div className="social-form-group">
          <label htmlFor="observation_children">
            Observações sobre filhos:
            <TooltipInfo text="Registre informações relevantes sobre os filhos do interno." />
          </label>
          <textarea
            id="observation_children"
            name="observation_children"
            value={formData.observation_children || ""}
            onChange={handleInputChange}
          />
        </div>
        {/* Parentes (Kin) */}
        <h4 className="h4-title">Parentes</h4>

        <button
          style={{ float: 'right' }}
          onClick={(e) => { e.stopPropagation(); setShowKinModal(true); }}
        >
          Adicionar Parente
        </button>

        <table className="table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>CPF</th>
              <th>Data de Nascimento</th>
              <th>Relacionamento</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {familiares.map((kin) => {
              return (
                <tr key={kin.id}>
                  <td>{kin?.name || "Sem nome"}</td>
                  <td>{kin?.cpf || "Sem CPF"}</td>
                  <td>{kin?.date_of_birth ? kin.date_of_birth.split('T')[0] : 'Data não informada'}</td>
                  <td>
                    {typeof kin.relationship === 'object' ? kin.relationship?.name : kin.relationship_name}
                  </td>
                  <td>
                    <button onClick={() => handleEditKin(kin)}>
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Modal criar parentes */}
        {showKinModal && (
          <Modal
            isOpen={true}
            onClose={handleCloseKinModal} closeModal={handleCloseKinModal}
            title={editingKinId ? "Editar Parente" : "Adicionar Parente"}
          >

            <div className="social-form-group">
              <label>Nome <span className="social-required-indicator">*</span></label>
              <input type="text" name="name" value={kinForm.name || ''} onChange={handleChangeKinForm} />
            </div>

            <div className="social-form-group-duplo">
              <div className="social-form-group">
                <label>CPF</label>
                <FormattedInput type="cpf" name="cpf" value={kinForm.cpf || ''} onChange={handleChangeKinForm} />
              </div>
              <div className="social-form-group">
                <label>RG</label>
                <input type="text" name="rg" value={kinForm.rg || ''} onChange={handleChangeKinForm} />
              </div>
            </div>

            <div className="social-form-group">
              <label>Nome Social</label>
              <input type="text" name="social_name" value={kinForm.social_name || ''} onChange={handleChangeKinForm} />
            </div>

            <div className="social-form-group-duplo">
              <div className="social-form-group">
                <label>Data de Nascimento</label>
                <input type="date" name="date_of_birth" value={kinForm.date_of_birth || ''} onChange={handleChangeKinForm} />
              </div>
              <div className="social-form-group">
                <label>Nacionalidade</label>
                <LocationAutocomplete
                  kind="country"
                  name="nationality_country"
                  value={kinNationalityName}
                  onChange={handleKinNationalityChange}
                  onSelect={handleKinNationalitySelect}
                />
              </div>
            </div>

            <div className="social-form-group">
              <label>Naturalidade</label>
              <LocationAutocomplete
                kind="city"
                name="naturalness_city"
                value={kinNaturalnessName}
                onChange={handleKinNaturalnessChange}
                onSelect={handleKinNaturalnessSelect}
              />
            </div>

            <div className="social-form-group">
              <label>Responsável</label>
              <input type="text" name="responsable" value={kinForm.responsable || ''} onChange={handleChangeKinForm} />
            </div>

            <div className="social-form-group">
              <label>Gênero</label>
              <select
                name="gender"
                value={kinForm.gender || ""}
                onChange={handleChangeKinForm}
              >
                <option value="">Selecione</option>
                {genders.map((g) => (
                  <option key={g.id} value={g.id}>{g.name}</option>
                ))}
              </select>
            </div>

            <div className="social-form-group">
              <label htmlFor="sexual_orientation">Orientação Sexual</label>
              <select
                name="sexual_orientation"
                value={kinForm.sexual_orientation || ""}
                onChange={handleChangeKinForm}
              >
                <option value="">Selecione</option>
                {sexualOrientations.map((g) => (
                  <option key={g.id} value={g.id}>{g.name}</option>
                ))}
              </select>
            </div>

            <div className="social-form-group">
              <label>Cor ou Etnia</label>
              <select
                name="color_or_ethnicity"
                value={kinForm.color_or_ethnicity || ""}
                onChange={handleChangeKinForm}
              >
                <option value="">Selecione</option>
                {colorsEthnicity.map((g) => (
                  <option key={g.id} value={g.id}>{g.name}</option>
                ))}
              </select>
            </div>

            <div className="social-form-group">
              <label>Estado Civil</label>
              <select
                name="marital_status"
                value={kinForm.marital_status || ""}
                onChange={handleChangeKinForm}
              >
                <option value="">Selecione</option>
                {maritalStatuses.map((g) => (
                  <option key={g.id} value={g.id}>{g.name}</option>
                ))}
              </select>
            </div>

            <div className="social-form-group">
              <label>Escolaridade</label>
              <select
                name="scholarity"
                value={kinForm.scholarity || ""}
                onChange={handleChangeKinForm}
              >
                <option value="">Selecione</option>
                {scholarities.map((g) => (
                  <option key={g.id} value={g.id}>{g.nivel}</option>
                ))}
              </select>
            </div>

            <div className="social-form-group">
              <label>Grau de parentesco <span className="social-required-indicator">*</span></label>
              <select
                name="relationship"
                value={kinForm.relationship || ""}
                onChange={handleChangeKinForm}
              >
                <option value="">Selecione</option>
                {relationships.map((g) => (
                  <option key={g.id} value={g.id}>{g.name}</option>
                ))}
              </select>
            </div>

            <div className="social-form-group">
              <label>Renda</label>
              <input type="text" name="income" value={kinForm.income || ""} onChange={handleChangeKinForm} />
            </div>

            <div className="social-form-group">
              <label>Já foi preso?</label>
              <select
                name="already_arrested"
                value={kinForm.already_arrested?.toString() || "false"}
                onChange={handleChangeKinForm}
              >
                <option value="false">Não</option>
                <option value="true">Sim</option>
              </select>
            </div>

            <div className="social-form-group">
              <label>Situação com a Justiça</label>
              <input type="text" name="situation_with_justice" value={kinForm.situation_with_justice || ""} onChange={handleChangeKinForm} />
            </div>

            <div className="social-form-group">
              <label>Observações</label>
              <textarea name="observation" value={kinForm.observation || ""} onChange={handleChangeKinForm}></textarea>
            </div>

            <button
              className="btn btn-success mt-3"
              onClick={editingKinId ? handleUpdateKinForm : handleSubmitKinForm}
              disabled={isKinSubmitting}
            >
              {isKinSubmitting
                ? 'Salvando...'
                : (editingKinId ? 'Atualizar Parente' : 'Salvar Parente')}
            </button>
          </Modal>
        )}

        <div style={{ marginTop: 20 }}>
          <button
            className={`save-btn${isSubmitting ? ' btn-disabled' : ''}`}
            disabled={isSubmitting}
            onClick={handleSaveWithPrimaryData}
          >
            {isSubmitting ? "Enviando..." : "Salvar Dados Familiares"}
          </button>
        </div>
      </div>
    );
  };

  // Renderização da aba 'Socioeconômico'
  const renderSocioeconomicoTab = () => (
    <div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Nacionalidade</label>
          <LocationAutocomplete
            kind="country"
            name="nationality_country"
            value={nationalityName}
            onChange={handleNationalityChange}
            onSelect={handleNationalitySelect}
          />
        </div>
        <div className='social-form-group'>
          <label>Naturalidade</label>
          <LocationAutocomplete
            kind="city"
            name="naturalness_city"
            value={naturalnessName}
            onChange={handleNaturalnessChange}
            onSelect={handleNaturalnessSelect}
          />
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Cor ou Etnia</label>
          <select name="color_or_ethnicity" value={formData.color_or_ethnicity || ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            {colorsEthnicity.map((color) => (
              <option key={color.id} value={color.id}>{color.name}</option>
            ))}
          </select>
        </div>
        <div className='social-form-group'>
          <label>Gênero</label>
          <select name="gender" value={formData.gender || ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            {genders.map((gender) => (
              <option key={gender.id} value={gender.id}>{gender.name}</option>
            ))}
          </select>
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Estado Civil</label>
          <select name="marital_status" value={formData.marital_status || ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            {maritalStatuses.map((status) => (
              <option key={status.id} value={status.id}>{status.name}</option>
            ))}
          </select>
        </div>
        <div className='social-form-group'>
          <label>Orientação Sexual</label>
          <select name="sexual_orientation" value={formData.sexual_orientation || ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            {sexualOrientations.map((orientation) => (
              <option key={orientation.id} value={orientation.id}>{orientation.name}</option>
            ))}
          </select>
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Religião</label>
          <select name="religion" value={formData.religion || ''} onChange={handleInputChange}>
            <option value="">Selecione a religião</option>
            {religions.map((religion) => (
              <option key={religion.id} value={religion.id}>{religion.name}</option>
            ))}
          </select>
        </div>
        <div className='social-form-group' />
      </div>
      <div className='social-form-group'>
        <label>Tipo de Visita
          <TooltipInfo text="Tipo de visita que o Interno deseja receber" />
        </label>
        <div className="checkbox-group2">
          {typeVisits.map((item) => (
            <label key={item.id}>
              <input
                type="checkbox"
                value={item.id}
                checked={formData.type_visit.includes(item.id)}
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  const isChecked = e.target.checked;
                  setFormData((prev) => ({
                    ...prev,
                    type_visit: isChecked
                      ? [...prev.type_visit, value]
                      : prev.type_visit.filter((id) => id !== value),
                  }));
                }}
              />
              {item.type}
            </label>
          ))}
        </div>
      </div>
      <div className='social-form-group'>
        <label>Programa Social
          <TooltipInfo text="Programa social onde o interno esteja cadastrado." />
        </label>
        <div className="checkbox-group2">
          {socialProgram.map((item) => (
            <label key={item.id}>
              <input
                type="checkbox"
                value={item.id}
                checked={formData.social_program.includes(item.id)}
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  const isChecked = e.target.checked;
                  setFormData((prev) => ({
                    ...prev,
                    social_program: isChecked
                      ? [...prev.social_program, value]
                      : prev.social_program.filter((id) => id !== value),
                  }));
                }}
              />
              {item.name}
            </label>
          ))}
        </div>
      </div>
      <div className='social-form-group'>
        <label>Família em Programa Social
          <TooltipInfo text="Programa social onde algum familiar do interno esteja cadastrado" />
        </label>
        <div className="checkbox-group2">
          {familySocialProgram.map((item) => (
            <label key={item.id}>
              <input
                type="checkbox"
                value={item.id}
                checked={formData.family_in_social_program.includes(item.id)}
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  const isChecked = e.target.checked;
                  setFormData((prev) => ({
                    ...prev,
                    family_in_social_program: isChecked
                      ? [...prev.family_in_social_program, value]
                      : prev.family_in_social_program.filter((id) => id !== value),
                  }));
                }}
              />
              {item.name}
            </label>
          ))}
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Recebe auxílio reclusão</label>
          <select name="prison_aid" value={formData.prison_aid !== undefined ? formData.prison_aid.toString() : ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
        <div className='social-form-group'>
          <label>Posição Econômica na Família</label>
          <select name="economic_position_in_family" value={formData.economic_position_in_family || ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="Arrimo">Arrímo da família</option>
            <option value="Parcial">Colaborava Parcialmente</option>
            <option value="Consumo Próprio">Consumo próprio</option>
          </select>
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Responsável pela Família</label>
          <select name="responsible_family" value={formData.responsible_family !== undefined ? formData.responsible_family.toString() : ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
        <div className='social-form-group'>
          <label>Renda</label>
          <input type="number" step="0.01" name="income" value={formData.income || ''} onChange={handleInputChange} />
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Responsável Atual pela Família</label>
          <input type="text" name="currently_responsible_for_family" value={formData.currently_responsible_for_family || ''} onChange={handleInputChange} />
        </div>
        <div className='social-form-group'>
          <label>Contato do Responsável Atual pela Família</label>
          <FormattedInput type="telefone" name="contact_currently_responsible" value={formData.contact_currently_responsible || ''} onChange={handleInputChange} />
        </div>
      </div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Responsável por Menor de 12 Anos</label>
          <select name="responsible_for_under_twelve" value={formData.responsible_for_under_twelve !== undefined ? formData.responsible_for_under_twelve.toString() : ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
        <div className='social-form-group'>
          <label>Responsável por Deficientes</label>
          <select name="responsible_for_disabled" value={formData.responsible_for_disabled !== undefined ? formData.responsible_for_disabled.toString() : ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
        <div className='social-form-group'>
          <label>Em Situação de Rua</label>
          <select name="street_situation" value={formData.street_situation !== undefined ? formData.street_situation.toString() : ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
      </div>
      <div className="social-form-group">
        <label htmlFor="voter_registration">Título de Eleitor:</label>
        <input
          type="text"
          id="voter_registration"
          name="voter_registration"
          value={formData.voter_registration || ""}
          onChange={handleInputChange}
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <button
          className={`save-btn${isSubmitting ? ' btn-disabled' : ''}`}
          disabled={isSubmitting}
          onClick={handleSaveWithPrimaryData}
        >
          {isSubmitting ? "Enviando..." : "Salvar Dados Socioeconômicos"}
        </button>
      </div>
    </div>
  );

  // Renderização da aba 'Trabalho'
  const renderTrabalhoTab = () => (
    <div>
      <div className='social-form-group-duplo'>
        <div className='social-form-group'>
          <label>Já Trabalhou</label>
          <select name="worked" value={formData.worked !== undefined ? formData.worked.toString() : ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
      </div>
      <div className='social-form-group'>
        <label>Profissão</label>
        <div className="checkbox-group2">
          {professions.map((profession) => (
            <label key={profession.id}>
              <input
                type="checkbox"
                value={profession.id}
                checked={(formData.profession || []).some((id) => Number(id) === Number(profession.id))}
                onChange={(e) => {
                  toggleArrayFieldValue('profession', e.target.value, e.target.checked);
                }}
              />
              {profession.name}
            </label>
          ))}
        </div>
      </div>

      <div className='social-form-group'>
          <label>Deseja Trabalhar na Unidade</label>
          <select name="work_in_the_unit" value={formData.work_in_the_unit !== undefined ? formData.work_in_the_unit.toString() : ''} onChange={handleInputChange}>
            <option value="">Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
      <div className='social-form-group'>
        <label>Observação sobre Trabalho</label>
        <input type="text" name="observation_about_work" value={formData.observation_about_work || ''} onChange={handleInputChange} />
      </div>
      <div style={{ marginTop: 20 }}>
        <button
          className={`save-btn${isSubmitting ? ' btn-disabled' : ''}`}
          disabled={isSubmitting}
          onClick={handleSaveOnlySocialService}
        >
          {isSubmitting ? "Enviando..." : "Salvar Dados de Trabalho"}
        </button>
      </div>
    </div>
  );

  // Renderização da aba 'Endereço'
  const renderEnderecoTab = () => (
    <div className='address-tab-content content-table'>
      <button className="add-address-button" onClick={handleAddAddress}>
        <FontAwesomeIcon icon={faPlus} /> Cadastra novo
      </button>
      {addresses.length > 0 ? (
        <table className="address-table">
          <thead>
            <tr>
              <th>Estado</th>
              <th>Cidade</th>
              <th>Bairro</th>
              <th>Logradouro</th>
              <th>Principal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {addresses.map((address) => (
              <tr key={address.id}>
                <td>{address.state}</td>
                <td>{address.city}</td>
                <td className='td-limited'>{address.neighborhood}</td>
                <td className='td-limited'>{address.public_place}</td>
                <td>{address.main ? 'Sim' : 'Não'}</td>
                <td>
                  <FontAwesomeIcon icon={faEdit} className="edit-address-button" onClick={() => handleEditAddress(address)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Nenhum endereço encontrado para este interno.</p>
      )}
      {isModalAddressOpen && (
        <Modal
          title={editingAddress ? 'Editar Endereço' : 'Adicionar Endereço'}
          isOpen={isModalAddressOpen}
          closeModal={closeModal}
        >
          {editingAddress ? (
            <EditAddress
              key={editingAddress.id}
              addressData={editingAddress}
              internalId={formData.internal}
              internalDetails={internalDetails}
              onSaveSuccess={closeModal}
              onCloseModal={() => {}}
            />
          ) : (
            <AddAddress
              onSaveSuccess={closeModal}
              onCloseModal={() => {}}
              internalId={formData.internal}
            />
          )}
        </Modal>
      )}
    </div>
  );

  // Renderização da aba 'Síntese'
  const renderSinteseTab = () => (
    <div>
      <h4>
        Síntese para o CTC
        <TooltipInfo text="Resumo técnico para acompanhamento no CTC." />
      </h4>
      <br></br>
      <div className='social-form-group'>
        <textarea name="synthesis" rows="4" value={formData.synthesis || ''} onChange={handleInputChange}></textarea>
      </div>
      <div style={{ marginTop: 20 }}>
        <button
          className={`save-btn${isSubmitting ? ' btn-disabled' : ''}`}
          disabled={isSubmitting}
          onClick={handleSaveOnlySocialService}
        >
          {isSubmitting ? "Enviando..." : "Salvar Síntese"}
        </button>
      </div>
    </div>
  );

  // Renderização da aba 'Evolução'
  const renderEvolucaoTab = () => (
    <div className="evolucao-container">
      <div className="social-form-group">
        <label>
          Registrar Evolução
          <TooltipInfo text="Registro clínico/social do atendimento realizado." />
        </label>
        <textarea
          name="evolution"
          rows="4"
          value={formData.evolution || ''}
          onChange={handleInputChange}
          placeholder="Descreva a evolução do interno"
        />
        <button className="social-submit-button" onClick={handleEvolutionSubmit} disabled={isEvolutionSubmitting}>
          {isEvolutionSubmitting ? 'Salvando...' : 'Adicionar Evolução'}
        </button>
      </div>
      <div className="timeline">
        <h4>Evoluções</h4>
        <ul className="timeline-list">
          {evolutions.length > 0 ? (
            [...evolutions]
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((evo, index) => (
              <li key={index} className="timeline-item">
                <div className="timeline-date">
                  <FontAwesomeIcon icon={faClock} /> {new Date(evo.date).toLocaleString()}
                </div>
                <div className="timeline-content">{evo.data}</div>
              </li>
              ))
          ) : (
            <p>Nenhuma evolução encontrada.</p>
          )}
        </ul>
      </div>
    </div>
  );

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        // Removido botão global de envio (children2)
        />

        <PageHeader
          title="Serviço social"
          subtitle="Atendimento social, vínculos familiares e acompanhamento."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <div className='social-service-layout'>
            <div className='social-tabs'>
              <button className={`social-tab-button ${currentTab === 'dados' ? 'active' : ''}`} onClick={() => setCurrentTab('dados')}>Dados</button>
              <button className={`social-tab-button ${currentTab === 'deficiency' ? 'active' : ''}`} onClick={() => setCurrentTab('deficiency')}>Deficiência</button>
              <button className={`social-tab-button ${currentTab === 'familiar' ? 'active' : ''}`} onClick={() => setCurrentTab('familiar')}>Familiar</button>
              <button className={`social-tab-button ${currentTab === 'socioeconomico' ? 'active' : ''}`} onClick={() => setCurrentTab('socioeconomico')}>Socioeconômico</button>
              <button className={`social-tab-button ${currentTab === 'trabalho' ? 'active' : ''}`} onClick={() => setCurrentTab('trabalho')}>Trabalho</button>
              <button className={`social-tab-button ${currentTab === 'endereco' ? 'active' : ''}`} onClick={() => setCurrentTab('endereco')}>Endereço</button>
              <button className={`social-tab-button ${currentTab === 'sintese' ? 'active' : ''}`} onClick={() => setCurrentTab('sintese')}>Síntese</button>
              <button className={`social-tab-button ${currentTab === 'evolucao' ? 'active' : ''}`} onClick={() => setCurrentTab('evolucao')}>Evolução</button>
            </div>

            <div className='social-tab-content'>
              {renderTabContent()}
            </div>
          </div>
        )}
      </div>


    </div>
  );
};

export default SocialService;
